import React from 'react'

const NegotiationDetailSkeleton: React.FC = () => {
    return (
        <div className="bg-white border border-gray-200 rounded-md shadow-sm animate-pulse">
            <div className="p-4">
                {/* Header with dates and status */}
                <div className="flex items-center justify-between mb-4 pb-3 border-b border-gray-100">
                    <div className="flex items-center gap-6">
                        <div className="h-3 bg-gray-200 rounded w-32"></div>
                        <div className="h-3 bg-gray-200 rounded w-32"></div>
                        <div className="h-3 bg-gray-200 rounded w-28"></div>
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="h-6 bg-gray-200 rounded-full w-20"></div>
                        <div className="h-6 bg-gray-200 rounded-full w-16"></div>
                    </div>
                </div>

                <div className="flex items-start justify-between">
                    <div className="flex-1">
                        {/* Title */}
                        <div className="mb-4">
                            <div className="h-6 bg-gray-200 rounded w-96 mb-2"></div>
                        </div>

                        {/* Grid info cards */}
                        <div className="bg-gray-50 rounded-lg p-4 mb-5">
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                {Array.from({ length: 6 }).map((_, index) => (
                                    <div
                                        key={index}
                                        className="bg-white rounded-lg p-3 border border-gray-100"
                                    >
                                        <div className="flex flex-col">
                                            <div className="h-3 bg-gray-200 rounded w-16 mb-1"></div>
                                            <div className="h-4 bg-gray-200 rounded w-24"></div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Assignees */}
                        <div className="mb-5">
                            <div className="bg-blue-50 rounded-lg p-3 border border-blue-100">
                                <div className="flex items-center gap-2">
                                    <div className="h-3 bg-gray-200 rounded w-20"></div>
                                    <div className="flex flex-wrap gap-2">
                                        {Array.from({ length: 3 }).map(
                                            (_, index) => (
                                                <div
                                                    key={index}
                                                    className="h-6 bg-gray-200 rounded-full w-16"
                                                ></div>
                                            )
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Content sections */}
                        <div className="space-y-4">
                            {/* Content */}
                            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                <div className="flex items-center gap-2 mb-3">
                                    <div className="h-4 bg-gray-200 rounded w-16"></div>
                                </div>
                                <div className="space-y-2">
                                    <div className="h-4 bg-gray-200 rounded w-full"></div>
                                    <div className="h-4 bg-gray-200 rounded w-4/5"></div>
                                    <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                                </div>
                            </div>

                            {/* Notes */}
                            <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
                                <div className="flex items-center gap-2 mb-3">
                                    <div className="w-4 h-4 bg-gray-200 rounded"></div>
                                    <div className="h-4 bg-gray-200 rounded w-12"></div>
                                </div>
                                <div className="space-y-2">
                                    <div className="h-4 bg-gray-200 rounded w-full"></div>
                                    <div className="h-4 bg-gray-200 rounded w-2/3"></div>
                                </div>
                            </div>

                            {/* Attachments */}
                            <div className="border border-gray-200 rounded-lg p-4">
                                <div className="h-4 bg-gray-200 rounded w-20 mb-3"></div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
                                    {Array.from({ length: 3 }).map(
                                        (_, index) => (
                                            <div
                                                key={index}
                                                className="bg-gray-50 rounded-lg p-3 border border-gray-200"
                                            >
                                                <div className="h-12 bg-gray-200 rounded mb-2"></div>
                                                <div className="h-3 bg-gray-200 rounded w-full mb-1"></div>
                                                <div className="h-3 bg-gray-200 rounded w-2/3"></div>
                                            </div>
                                        )
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Actions and History */}
                        <div className="mt-6 pt-4 border-t border-gray-100">
                            {/* Action buttons */}
                            <div className="flex flex-wrap gap-2 mb-4 justify-end">
                                {Array.from({ length: 3 }).map((_, index) => (
                                    <div
                                        key={index}
                                        className="h-8 bg-gray-200 rounded w-20"
                                    ></div>
                                ))}
                            </div>

                            {/* History section */}
                            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                <div className="h-5 bg-gray-200 rounded w-16 mb-4"></div>
                                <div className="space-y-3">
                                    {Array.from({ length: 4 }).map(
                                        (_, index) => (
                                            <div
                                                key={index}
                                                className="bg-white rounded-lg p-3 border border-gray-200"
                                            >
                                                <div className="flex items-center justify-between mb-2">
                                                    <div className="h-4 bg-gray-200 rounded w-32"></div>
                                                    <div className="h-3 bg-gray-200 rounded w-20"></div>
                                                </div>
                                                <div className="space-y-2">
                                                    <div className="h-3 bg-gray-200 rounded w-full"></div>
                                                    <div className="h-3 bg-gray-200 rounded w-3/4"></div>
                                                </div>
                                                <div className="flex items-center justify-between mt-3">
                                                    <div className="h-3 bg-gray-200 rounded w-24"></div>
                                                    <div className="h-6 bg-gray-200 rounded-full w-16"></div>
                                                </div>
                                            </div>
                                        )
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NegotiationDetailSkeleton
